module.exports = "<p>\r\n  The SMART on FHIR App has been launched from EMR......\r\n</p>\r\n"